import moment from "moment";
import {
  Card,
  Button,
  Stack,
  OverlayTrigger,
  Tooltip,
  ListGroup,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import "components/Products/Products.css";

export default function MaintenanceCard({ card }) {
  const getStatusColor = () => {
    if (card?.status_sort === "Certified") {
      return "bg-green";
    } else if (card?.status_sort === "Archived") {
      return "bg-archived";
    } else {
      return "bg-yellow";
    }
  };

  const getCardName = () => {
    return card?.status_sort;
  };
  return (
    <Card className="shadow bg-product product-card">
      <p className={"text-center text-uppercase " + getStatusColor()}>
        {getCardName()}
      </p>
      <Card.Body>
        <Card.Text className="d-flex px-3">
          <small>{card?.vendor_id_name}</small>
        </Card.Text>
        <h4 className="px-3 pb-3">
          <strong>{card?.product_name}</strong>
        </h4>
        <div className="d-flex px-3 my-3">
          {card?.status_sort === "Certified" && (
            <>
              <Stack className="card-info">
                <p className="mb-0">Certification Date</p>
                <strong>
                  {moment.utc(card?.certification_date).format("MM/DD/YYYY")}
                </strong>
              </Stack>
              <Stack className="card-info">
                <p className="mb-0">Assurance Maintenance Date</p>
                <strong>
                  {moment.utc(card?.am_sort).format("MM/DD/YYYY")}
                </strong>
              </Stack>
            </>
          )}
          {card?.status_sort === "In Progress" && (
            <Stack className="card-info">
              <p className="mb-0">Kickoff Date</p>
              <strong>
                {moment.utc(card?.kicked_off_date).format("MM/DD/YYYY")}
              </strong>
            </Stack>
          )}
          <Stack className="card-info">
            <p className="mb-0">Conformance Claims:</p>
            <ListGroup>
              {card?.protection_profiles?.map((pp) => (
                <OverlayTrigger
                  key={`${card?.product_id}-${pp?.pp_id}`}
                  placement="left"
                  overlay={<Tooltip>{pp?.pp_name}</Tooltip>}
                >
                  <div>
                    <Link to={`/protectionprofiles/${pp?.pp_id}`}>
                      <strong className="py-0 my-0 overflow-ellipsis">
                        {pp?.pp_short_name || pp?.pp_name}
                      </strong>
                    </Link>
                  </div>
                </OverlayTrigger>
              ))}
            </ListGroup>
          </Stack>
        </div>
        <div className="d-flex px-3 my-3">
          <Stack className="card-info">
            <p className="mb-0">CCTL</p>
            <strong>{card?.assigned_lab_name}</strong>
          </Stack>
          {card?.from_cc_portal ? (
            <div></div>
          ) : (
            <Stack className="card-info">
              <p className="mb-0">VID</p>
              <strong>{card?.v_id}</strong>
            </Stack>
          )}
          <Stack className="card-info">
            <p className="mb-0">Maintenance Updates:</p>
            {card?.active_maintenances?.map((maintenance) => (
              <strong
                key={`${card?.product_id}-${maintenance?.maintenance_id}`}
              >
                {moment.utc(maintenance?.completion_date).format("YYYY.MM.DD")}
                &nbsp;
                {card?.status_sort === "Archivevd" ? (
                  <span>{maintenance?.title}</span>
                ) : card?.from_cc_portal ? (
                  <Link
                    to={`/products/international-product/${card?.product_id}/assurancemaintenance/${maintenance?.maintenance_id}`}
                  >
                    {maintenance?.title}
                  </Link>
                ) : (
                  <Link
                    to={`/products/${card?.product_id}/assurancemaintenance/${maintenance?.maintenance_id}`}
                  >
                    {maintenance?.title}
                  </Link>
                )}
              </strong>
            ))}
          </Stack>
        </div>
        <Card.Text className="d-flex flex-wrap px-3 my-3 align-items-center">
          {card?.submitting_country_id_code && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="button-tooltip-2">
                  {card?.submitting_country_id_name}
                </Tooltip>
              }
            >
              {({ ref, ...triggerHandler }) => (
                <img
                  ref={ref}
                  {...triggerHandler}
                  src={`/images/flags2/${card?.submitting_country_id_code?.toLowerCase()}.png`}
                  className="me-5"
                  height="50px"
                  alt="Country Flag"
                />
              )}
            </OverlayTrigger>
          )}
          {card?.status_sort === "Certified" && (
            <Link
              to={
                !card?.from_cc_portal
                  ? `/products/${card?.product_id}`
                  : `/products/international-product/${card?.product_id}`
              }
            >
              <Button variant="light" className="border-dark ms-auto btn-hover">
                Full Details
              </Button>
            </Link>
          )}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
